import BaseCommentApi from "../BaseCommentApi";

export default abstract class BaseCommentIdApi extends BaseCommentApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/${params["commentId"]}`;
	}
}
